'use client';

import { FC } from 'react';
import { IFilterObject } from '@/components/Product/Filters/types';
import DesktopFilters from '@/components/Product/Filters/DesktopFilters';
import MobileFilters from '@/components/Product/Filters/MobileFilters';
import { useGetCategoriesQuery } from '@/store/apis/app.categories';
import { IAppCategory } from '@/types/api/app/category';
import { skipToken } from '@reduxjs/toolkit/query';

interface FiltersProps {
  valueRange?: number[];
  onValueRangeChange?: (range: number[]) => void;

  categories?: IAppCategory[];
  onCategoriesChange?: (categories: IAppCategory[]) => void;

  filters?: IFilterObject[];
  onFiltersChange?: (val: IFilterObject[]) => void;

  disabledFiltering?: Array<'value' | 'metal' | 'category'>;
}
const Filters: FC<FiltersProps> = ({
  valueRange,
  onValueRangeChange,
  categories,
  onCategoriesChange,
  filters = [],
  onFiltersChange,
  disabledFiltering,
}) => {
  const {
    data: categoryOptions = [],
    isLoading: isGetCategoriesLoading,
    isFetching: isGetCategoriesFetching,
  } = useGetCategoriesQuery(
    disabledFiltering?.includes('category') ? skipToken : {}
  );

  const isLoading = isGetCategoriesLoading || isGetCategoriesFetching;

  return (
    <>
      <MobileFilters
        filters={filters}
        onFiltersChange={onFiltersChange}
        valueRange={valueRange}
        onValueRangeChange={onValueRangeChange}
        categories={categories}
        categoryOptions={categoryOptions}
        onCategoriesChange={onCategoriesChange}
      />
      <DesktopFilters
        filters={filters}
        onFiltersChange={onFiltersChange}
        valueRange={valueRange}
        onValueRangeChange={onValueRangeChange}
        categories={categories}
        categoryOptions={categoryOptions}
        onCategoriesChange={onCategoriesChange}
        isLoading={isLoading}
      />
    </>
  );
};

export default Filters;
